import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.59941 1.50083C5.12002 1.50083 2.29941 4.32144 2.29941 7.80083C2.29941 11.2802 5.12002 14.1008 8.59941 14.1008C12.0788 14.1008 14.8994 11.2802 14.8994 7.80083C14.8994 4.32144 12.0788 1.50083 8.59941 1.50083ZM0.899414 7.80083C0.899414 3.54824 4.34682 0.10083 8.59941 0.10083C12.852 0.10083 16.2994 3.54824 16.2994 7.80083C16.2994 12.0534 12.852 15.5008 8.59941 15.5008C4.34682 15.5008 0.899414 12.0534 0.899414 7.80083ZM8.59941 4.30083C8.98601 4.30083 9.29941 4.61423 9.29941 5.00083V7.80083C9.29941 8.18743 8.98601 8.50083 8.59941 8.50083C8.21281 8.50083 7.89941 8.18743 7.89941 7.80083V5.00083C7.89941 4.61423 8.21281 4.30083 8.59941 4.30083ZM7.89941 10.6008C7.89941 10.2142 8.21281 9.90083 8.59941 9.90083H8.60641C8.99301 9.90083 9.30641 10.2142 9.30641 10.6008C9.30641 10.9874 8.99301 11.3008 8.60641 11.3008H8.59941C8.21281 11.3008 7.89941 10.9874 7.89941 10.6008Z",
  fill: "#767676"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };